<template>
    <div class="my-whatsapp">
        <button class="whatsapp-icon">
            <a class="social whatsapp" :href="whatsapp_link" target="_blank">
                <b-icon icon="whatsapp"></b-icon>
            </a>
        </button>
    </div>
</template>

<script>
export default {
    name: "Whatsapp",
    data() {
        return {
            whatsapp_link: '',
            whatsapp: ''
        };
    },
    methods: {
        getData() {
            this.lang = localStorage.getItem("lang");
            this.axios.get(this.$store.state.url + "contact-us")
                .then(res => {
                    this.data = res.data.list
                    this.initData(this.data)
                });
        },
        initData(data) {
            data.forEach(element => {
                if (element.name == 'Whatsapp') {
                    this.whatsapp = element.value
                    this.whatsapp_link = "https://wa.me/00963" + this.whatsapp
                }
            });
        }
    },
    mounted() {
        this.getData()
    }
};
</script>


<style>
.my-whatsapp .whatsapp-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    z-index: 10000;
    right: 2%;
    top: 88%;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: var(--main-green);
    box-shadow: 0 0px 15px rgba(30, 115, 148, 0.342);
    cursor: pointer;
    border: none;
    transition: all ease-in;
}

@media (max-width: 767px) {
    .my-whatsapp .whatsapp-icon {
        display: none !important;
    }
}

.my-whatsapp .bi-whatsapp {
    color: #fff;
    font-size: 30px;
}
</style>
